import { render, staticRenderFns } from "./manual-statements.vue?vue&type=template&id=095b3266&scoped=true"
import script from "./manual-statements.vue?vue&type=script&lang=js"
export * from "./manual-statements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095b3266",
  null
  
)

export default component.exports